import updAPI from "@/api/upd";

const searchError = {
  code: null,
  message: null,
};
const state = {
  isUpdSearchFormSubmitting: false,
  currentUpd: null,
  isCreated: false,
  isPrepaidCreated: false,
  updSearchError: searchError,
  updSum: null,
  goods: [],
  isCorrectingSum: false,
  showSearchLoader: false,
  showRejectLoader: false,
  contractorEmail: null,
  isPaid: false,
  debt: 0,
  updRejectResult: null,
};

const mutations = {
  setUpdRejectResult(state, payload) {
    state.updRejectResult = payload;
  },
  updateContractorEmail(state, payload) {
    state.contractorEmail = payload;
  },
  startCorrectSum(state) {
    state.isCorrectingSum = true;
  },
  finishCorrectSum(state) {
    state.isCorrectingSum = false;
  },
  clearError(state) {
    state.updSearchError = {
      code: null,
      message: null,
    };
  },
  clearUpd(state) {
    state.isUpdSearchFormSubmitting = false;
    state.currentUpd = null;
    state.updSearchError = searchError;
    state.contractorEmail = null;
    state.goods = [];
    state.isPaid = false;
    state.debt = 0;
  },
  searchStart(state) {
    state.isUpdSearchFormSubmitting = true;
    state.showSearchLoader = true;
  },
  searchSuccess(state, payloads) {
    state.updRejectResult = null;
    console.log(payloads.updRejectIsExist === true);
    state.isUpdSearchFormSubmitting = true;
    if (payloads.updRejectIsExist === true) {
      state.updRejectResult = "exists";
    }
    state.currentUpd = payloads;
    state.updSum = payloads.clientPay;
    state.contractorEmail = payloads.contractor.email;
    payloads.goods.forEach((item) =>
      state.goods.push({
        id: item.rowNumber, // порядковый номер
        article: item.article, // артикул
        ext_id: item.extid, // внешний id
        link_master: item.linkMaster, // process resource tb id
        name: item.name, // наименование
        quantity: item.quantity, // текущее количество
        initial_amount: item.quantity, // изначальное количество
        price: item.price, // стоимость
        one_item_price: item.itemPrice.toFixed(2), // цена за одну позицию
        deleted: 0, // количество удаленных позиций
        packing_indivisble: item.packingIndivisible, // признак неделимого товара (нельзя удалять по одной позиции)
        packing_ration:
          item.packingIndivisible === true ? item.packingRation : 1, // кратность при удалении позиций
        draftUkdList: [],
      })
    );

    if (payloads.clientPay > 0) {
      state.currentUpd.goods = state.goods;
    } else {
      state.isPaid = true;
    }

    state.showSearchLoader = false;
  },
  deleteGood(state, payload) {
    state.debt = parseFloat(state.debt);
    state.goods.forEach(function (item, index) {
      if (item.id === payload.goodId) {
        item.deleted += payload.quantity;
        item.quantity = item.quantity - payload.quantity;
        item.price = parseFloat(item.price);
        item.price -= item.one_item_price * payload.quantity;
        item.price = item.price.toFixed(2);
        state.goods.splice(index, 1, item);
        state.debt +=
          item.one_item_price * item.packing_ration * payload.quantity;
      }
    });
    state.currentUpd.goods = state.goods;
  },
  rawDeleteGood(state, goodId) {
    state.goods.forEach(function (item, index) {
      if (item.id == goodId) {
        item.deleted += item.packing_ration;
        item.quantity -= item.packing_ration;
        item.price = parseFloat(item.price);
        item.price -= item.one_item_price * item.packing_ration;
        item.price = item.price.toFixed(2);
        state.goods.splice(index, 1, item);
      }
    });
    state.currentUpd.goods = state.goods;
  },
  restoreGood(state, payload) {
    state.goods.forEach(function (item, index) {
      if (item.id === payload.good_id) {
        item.deleted -= payload.quantity;
        item.quantity += payload.quantity;
        item.price = parseFloat(item.price);
        item.price += item.one_item_price * payload.quantity;
        item.price = item.price.toFixed(2);
        state.goods.splice(index, 1, item);
        state.debt = parseFloat(state.debt);
        state.debt -=
          item.one_item_price * item.packing_ration * payload.quantity;
      }
    });
    state.currentUpd.goods = state.goods;
  },
  rawRestoreGood(state, goodId) {
    state.goods.forEach(function (item, index) {
      if (item.id == goodId) {
        item.deleted -= item.packing_ration;
        item.quantity += item.packing_ration;
        item.price = parseFloat(item.price);
        item.price += item.one_item_price * item.packing_ration;
        item.price = item.price.toFixed(2);
        state.goods.splice(index, 1, item);
      }
    });
    state.currentUpd.goods = state.goods;
  },

  createStart(state) {
    state.showSearchLoader = true;
    state.isCreated = false;
  },
  createSuccess(state) {
    state.isCreated = true;
    state.isPrepaidCreated = false;
    state.showSearchLoader = false;
  },
  createFailure(state) {
    state.isCreated = false;
    state.showSearchLoader = false;
  },
  createPrepaidStart(state) {
    state.showSearchLoader = true;
    state.isPrepaidCreated = false;
  },
  createPrepaidSuccess(state) {
    state.isPrepaidCreated = true;
    state.showSearchLoader = false;
  },
  createPrepaidFailure(state) {
    state.isPrepaidCreated = false;
    state.showSearchLoader = false;
  },
  searchFailure(state, payload) {
    state.isUpdSearchFormSubmitting = false;
    state.updSearchError.code = payload.code;
    if (payload.code === 404) {
      state.updSearchError.message =
        "По номеру " + payload.searchNumber + " не найдено ни одного УПД";
    } else {
      state.updSearchError.message = payload.message;
    }
    state.showSearchLoader = false;
  },
  updateSum(state, payload) {
    state.updSum = parseFloat(payload).toFixed(2);
  },
  rawUpdateSum(state, payload) {
    state.updSum = payload;
  },
};

const getters = {
  searchNumber(state) {
    if (state.currentUpd !== null) {
      return state.currentUpd.searchNumber;
    }
    return null;
  },
  isUpdRejectIsExist(state) {
    return state.currentUpd !== null && state.currentUpd.updRejectIsExist;
  },
  updRejectResult(state) {
    if (state.updRejectResult === "success") {
      return {
        type: "success",
        text: "Клиент отказался от всех позиций",
      };
    }
    if (state.updRejectResult === "exists") {
      return {
        type: "warning",
        text: "Заявка на отказ уже была сформирована ранее",
      };
    }
    if (state.updRejectResult === "uks_exists") {
      return {
        type: "warning",
        text: "Отказ от всех позиций невозможен (существует корректировка)",
      };
    }
    if (state.updRejectResult === "error") {
      return {
        type: "error",
        text: "Ошибка отправки заявки на отказ от всех позиций",
      };
    }
    return null;
  },
  currentUpd(state) {
    return state.currentUpd;
  },
  goodsForReturnIsAvailable(state) {
    return state.goods.length > 0;
  },
  goods(state) {
    return state.goods;
  },
  updSearchError(state) {
    return state.updSearchError;
  },
  updSum(state) {
    return parseFloat(state.updSum);
  },
  isCorrectingSum(state) {
    return state.isCorrectingSum;
  },
  isCreated(state) {
    return state.isCreated;
  },
  isPaid(state) {
    return state.isPaid;
  },
  debt(state) {
    return state.debt;
  },
  isPrepaidCreated(state) {
    return state.isPrepaidCreated;
  },
  showSearchLoader(state) {
    return state.showSearchLoader;
  },
  getContractorEmail(state) {
    return state.contractorEmail;
  },
};

const actions = {
  setUpdRejectResult(context, payload) {
    context.commit("setUpdRejectResult", payload);
  },
  search_upd_by_number(context, searchNumber) {
    context.commit("searchStart");
    state.updSearchError = {
      code: null,
      message: null,
    };
    return new Promise((resolve) => {
      updAPI
        .search_upd(searchNumber)
        .then((response) => {
          context.commit("searchSuccess", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          context.commit("searchFailure", {
            code: error.response.status,
            message: error.response.data.message,
            searchNumber: searchNumber,
          });
        });
    });
  },

  create_new_upd(context, upd) {
    context.commit("createStart");
    return new Promise((resolve, reject) => {
      updAPI
        .create_upd(upd)
        .then((response) => {
          context.commit("createSuccess");
          resolve(response);
        })
        .catch((result) => {
          context.commit("createFailure");
          reject(result);
        });
    });
  },

  updReject(context, searchNumber) {
    return new Promise((resolve, reject) => {
      updAPI
        .reject_upd(searchNumber)
        .then((response) => {
          resolve(response);
        })
        .catch((result) => {
          reject(result);
        });
    });
  },

  create_new_prepaid(context, upd) {
    context.commit("createPrepaidStart");
    return new Promise((resolve, reject) => {
      updAPI
        .create_upd(upd)
        .then((response) => {
          context.commit("createPrepaidSuccess");
          resolve(response);
        })
        .catch((result) => {
          context.commit("createPrepaidFailure");
          reject(result);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
